@import "~@govbr-ds/core/src/components/footer/mixins";
@include footer-info;

:host {
  display: block;
}

.info {
  ::slotted(*) {
    font-size: var(--font-size-scale-down-01) !important;
    font-weight: 500 !important;
  }
}
